var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { makeStyles } from "../../styles/index";
import React, { useCallback, useState } from 'react';
import { IconButton } from "../IconButton/IconButton";
import { ColorButton } from "./ColorButton";
import { ColorPicker } from "./ColorPicker";
import BtnMorecolor from "./parts/BtnMorecolor";
import { getColorListWithTransparent, getOpacityColorList, NormalColorList } from "./utils/ColorUtils";
var useStyles = makeStyles(function (theme) { return ({
    itemList: {
        padding: theme.spacing(0, 1, 0, 2),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}); }, { name: 'SnColorSelector' });
export var ColorSelector = React.memo(function (props) {
    var currentColor = props.currentColor, onClick = props.onClick, _a = props.colorList, colorList = _a === void 0 ? NormalColorList : _a, useOpacity = props.useOpacity, useColorPicker = props.useColorPicker, useTransparent = props.useTransparent, colorPalletOptions = __rest(props, ["currentColor", "onClick", "colorList", "useOpacity", "useColorPicker", "useTransparent"]);
    var _b = useState(false), openColorPicker = _b[0], setOpenColorPicker = _b[1];
    var _c = useState(null), colorPalletRef = _c[0], setColorPickerRef = _c[1];
    var classes = useStyles();
    var handleSetColorPickerRef = useCallback(function (ref) { return setColorPickerRef(ref); }, []);
    var handleOpenColorPicker = useCallback(function () { return setOpenColorPicker(!openColorPicker); }, [openColorPicker]);
    var handleCloseColorPicker = useCallback(function () {
        setOpenColorPicker(false);
    }, []);
    var displayColorList = (function () {
        var opacityOrNormalColorList = useOpacity ? getOpacityColorList(colorList) : colorList;
        return useTransparent ? getColorListWithTransparent(opacityOrNormalColorList) : opacityOrNormalColorList;
    })();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.itemList },
            displayColorList.map(function (item) { return (React.createElement(ColorButton, { key: item, iconColor: item, active: currentColor === item, onClick: function () { return onClick(item); } })); }),
            useColorPicker && (
            // ColorButton.tsxを参考に作成
            React.createElement(IconButton, { ref: handleSetColorPickerRef, onClick: handleOpenColorPicker },
                React.createElement(BtnMorecolor, { style: { color: '#000000' } })))),
        useColorPicker && (React.createElement(ColorPicker, __assign({ open: openColorPicker, onClick: onClick, onClose: handleCloseColorPicker, anchorEl: colorPalletRef, currentColor: currentColor, useOpacity: useOpacity, useTransparent: useTransparent }, colorPalletOptions)))));
});
